module.exports = __webpack_public_path__ + "static/media/cat.4c8fda9c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-conclusions/images/cat.gif
// module id = 882
// module chunks = 0